import { get, post } from "../../utils/net";

import type { UserPreferencesEntity } from "../../models";

const baseURL = `${process.env.REACT_APP_API_PATH}/api/UserPreferences`;

const getUserPreferences = (): Promise<UserPreferencesEntity[]> => {
  const url = baseURL;

  const extraOptions = {
    useExactPath: true,
  };

  return get(url, extraOptions).then((result) => result.body);
};

const setPreference = (preference: string, value: any): Promise<UserPreferencesEntity> => {
  const url = `${baseURL}/${preference}`;

  const extraOptions = {
    useExactPath: true,
  };

  return post(url, value, extraOptions).then(() => mapUserPreference(preference, value));
};

const mapUserPreference = (key: string, value: object): UserPreferencesEntity => ({
  key,
  value: value || undefined,
});

export const userPreferencesAPI = {
  getUserPreferences,
  setPreference,
};
